/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Flex, Image, Text } from "@aws-amplify/ui-react";
import Spacer from "./Spacer";
import KanshiAntennaindicator from "./KanshiAntennaindicator";
export default function HeaderLocal(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="0"
      direction="row"
      width="1355px"
      height="unset"
      justifyContent="center"
      alignItems="center"
      position="relative"
      boxShadow="0px 0px 8px rgba(0, 0, 0, 0.10000000149011612)"
      padding="16px 40px 16px 40px"
      backgroundColor="rgba(255,255,255,1)"
      {...rest}
      {...getOverrideProps(overrides, "HeaderLocal")}
    >
      <Flex
        gap="8px"
        direction="row"
        width="unset"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-end"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Title")}
      >
        <Text
          fontFamily="Noto Sans"
          fontSize="16px"
          fontWeight="700"
          color="rgba(53,56,59,1)"
          lineHeight="16px"
          textAlign="left"
          display="block"
          direction="column"
          justifyContent="unset"
          letterSpacing="0.65px"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="5G共同テレポート総合監視システム"
          {...getOverrideProps(overrides, "text")}
        ></Text>
        <Image
          width="108px"
          height="14px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          objectFit="cover"
          {...getOverrideProps(overrides, "logo")}
        ></Image>
      </Flex>
      <Spacer
        display="flex"
        gap="10px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="center"
        alignItems="center"
        overflow="hidden"
        grow="1"
        shrink="1"
        basis="0"
        position="relative"
        padding="10px 10px 10px 10px"
        {...getOverrideProps(overrides, "Spacer547512497")}
      ></Spacer>
      <Text
        fontFamily="Noto Sans"
        fontSize="16px"
        fontWeight="500"
        color="rgba(53,56,59,1)"
        lineHeight="16px"
        textAlign="center"
        display="block"
        direction="column"
        justifyContent="unset"
        letterSpacing="0.65px"
        width="unset"
        height="unset"
        gap="unset"
        alignItems="unset"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="2022/10/03（月） 00:00:00"
        {...getOverrideProps(overrides, "time")}
      ></Text>
      <Spacer
        display="flex"
        gap="10px"
        direction="column"
        width="unset"
        height="unset"
        justifyContent="center"
        alignItems="center"
        overflow="hidden"
        grow="1"
        shrink="1"
        basis="0"
        position="relative"
        padding="10px 10px 10px 10px"
        {...getOverrideProps(overrides, "Spacer547512499")}
      ></Spacer>
      <Flex
        gap="16px"
        direction="row"
        width="192px"
        height="40px"
        justifyContent="flex-end"
        alignItems="center"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Indicator")}
      >
        <Text
          fontFamily="Noto Sans"
          fontSize="14px"
          fontWeight="500"
          color="rgba(100,100,100,1)"
          lineHeight="14px"
          textAlign="center"
          display="block"
          direction="column"
          justifyContent="unset"
          letterSpacing="0.55px"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="AWS通信状態"
          {...getOverrideProps(overrides, "IndicatorText")}
        ></Text>
        <KanshiAntennaindicator
          width="56px"
          height="16px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          shrink="0"
          position="relative"
          borderRadius="2px"
          padding="0px 0px 0px 0px"
          backgroundColor="rgba(38,193,147,1)"
          type="Default"
          {...getOverrideProps(overrides, "Kanshi/Antenna/indicator")}
        ></KanshiAntennaindicator>
      </Flex>
    </Flex>
  );
}
